import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { InternalTransfer, getInternalTransfer } from '../../details'
import { RejectInternalTransfer, RejectInternalTransferForm } from './types'
import {
  internalTransferStatus,
  transactionRequestStatus,
} from '../../../const'
import { internalTransferMounted } from '../../list/model'

export const mounted = createEvent()
export const unmounted = createEvent()

export const setReject = createEvent<RejectInternalTransferForm>()
export const $reject = restore<RejectInternalTransferForm>(setReject, {
  rejectReason: '',
})

// submit reject

export const submitReject = createEvent<RejectInternalTransfer>()

export const rejectTransactionRequest = fx<
  RejectInternalTransfer,
  InternalTransfer
>({
  method: 'PUT',
  url: `/internal_transfer/`,
})

sample({
  clock: submitReject,
  fn: ({ requestId, manualTransferReason }) => {
    return {
      body: {
        requestId: requestId,
        status: internalTransferStatus.rejected(),
        manualTransferReason: manualTransferReason,
      },
      url: `/internal_transfer/${requestId}`,
    }
  },
  target: rejectTransactionRequest,
})

// clear field on success

sample({
  clock: rejectTransactionRequest.done,
  fn: () => ({}),
  target: [internalTransferMounted],
})
